import type { FC, ReactElement } from "react";

import type { BaseCellProps } from "@similarweb/pro-logic-components";

import { StyledItemsCount, StyledItemsCountBaseCell } from "./styles";

type TItemsCountCellProps = BaseCellProps & {
    value: number;
};

export const ItemsCountCell: FC<TItemsCountCellProps> = ({ value, ...otherProps }): ReactElement | null => {
    if (value === 0) {
        return null;
    }

    return (
        <StyledItemsCountBaseCell {...otherProps}>
            <StyledItemsCount>{value}</StyledItemsCount>
        </StyledItemsCountBaseCell>
    );
};
